// @flow
export { default } from './ProductPrice';



// WEBPACK FOOTER //
// ./src/components/product/ProductPrice/index.js